module.exports = __webpack_public_path__ + "assets/img/hjicon3.3d400673.png";